<script>
import { ColladaLoader } from "three/examples/jsm/loaders/ColladaLoader";
import mixin from "./AugmentableMixin.vue";

import { PMREMGenerator, UnsignedByteType } from "three";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader.js";

export default {
  name: "AugmentableCollada",
  mixins: [mixin],
  props: {
    lights: {
      type: Array,
      default() {
        return [
          {
            type: "HemisphereLight",
            position: { x: 0, y: 1, z: 0 },
            skyColor: 0xaaaaff,
            groundColor: 0x806060,
            intensity: 0.2,
          },
          {
            type: "DirectionalLight",
            position: { x: 1, y: 1, z: 1 },
            color: 0xffffff,
            intensity: 0.8,
          },
        ];
      },
    },
    smoothing: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    const loader = new ColladaLoader();
    loader.setCrossOrigin(this.crossOrigin);
    return {
      loader,
    };
  },
  methods: {
    getObject(collada) {
      return collada.scene;
    },
    changeEnvironmentImage() {
      let { environmentImage } = this;

      if (!this.src) return;

      let { scene } = this;

      const pmremGenerator = new PMREMGenerator(this.renderer);
      pmremGenerator.compileEquirectangularShader();
      new RGBELoader()
        .setDataType(UnsignedByteType)
        .load(environmentImage, function (texture) {
          var envMap = pmremGenerator.fromEquirectangular(texture).texture;

          scene.environment = envMap;

          texture.dispose();
          pmremGenerator.dispose();
        });
    },
    changeSkyboxImage() {
      let { skyboxImage } = this;

      if (!this.src) return;

      let { scene } = this;
      if (skyboxImage) {
        const pmremGenerator = new PMREMGenerator(this.renderer);
        pmremGenerator.compileEquirectangularShader();
        new RGBELoader()
          .setDataType(UnsignedByteType)
          .load(skyboxImage, function (texture) {
            var envMap = pmremGenerator.fromEquirectangular(texture).texture;

            scene.background = envMap;

            texture.dispose();
            pmremGenerator.dispose();
          });
      } else {
        scene.background = null;
      }
    },
    changeExposure() {
      let { exposure } = this;
      let { renderer } = this;
      renderer.toneMappingExposure = exposure;
    },
  },
};
</script>